import assessmentDecisionReducer from "./assessmentDecisionReducer";
import inspectionApplicationReducer from "./inspectionApplicationReducer";
import inspectionResultReducer from "./inspectionResultReducer";

const assessmentDataReducers = {
    assessmentDecision: assessmentDecisionReducer,
    inspectionApplication: inspectionApplicationReducer,
    inspectionResult: inspectionResultReducer,
}

export default assessmentDataReducers;